import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import excluirControleEmissaoBpeUsuario from '../../actions/bpe/excluirControleEmissaoBpeUsuario';
import { showSuccessMsg } from '../../util/messagesUtil';
import $ from 'jquery';
import { formasPagamentoControleEmissaoBpe } from '../../util/constantsUtil';

const CabecalhoTabelaControleUsuario = () => (
  <div id="header-tabela-controle-usuario" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
    <div className="row cabecalho-desktop">
      <div className="col-lg-4 col-xl-4" style={{ textAlign: 'left' }}>Usuário</div>
      <div className="col-md-4 col-md-4" style={{ textAlign: 'left' }}>Email</div>
      <div className="col-md-2 col-md-2" style={{ textAlign: 'left' }}>Tipos de Pagamento</div>
      <div className="col-lg-2 col-xl-2">Ações</div>
    </div>
  </div>
);

const ControleUsuarioItem = ({ controle, editar, excluir, getLabelTipoPagamento }) => (
  <div className="representante">
    <div className="resumo">
      <div className="row">
        <div className="col-lg-4 col-xl-4" style={{ textAlign: 'left' }}>
          <span className="titulo-mobile">Usuário:&nbsp;</span>{controle.nomeUsuario}
        </div>
        <div className="col-lg-4 col-xl-4" style={{ textAlign: 'left' }}>
          <span className="titulo-mobile">Email:&nbsp;</span>{controle.emailUsuario}
        </div>
        <div className="col-lg-2 col-xl-2" style={{ textAlign: 'left' }}>
          <span className="titulo-mobile">Tipos de Pagamento:&nbsp;</span>
          {controle.tiposPagamento && controle.tiposPagamento.length > 0
            ? controle.tiposPagamento.map(cod => getLabelTipoPagamento(cod)).join(', ')
            : '-'}
        </div>
        <div className="col-lg-2 col-xl-2" style={{ textAlign: 'left' }}>
          <div className="acoes">
            <div className="botoes">
              <button 
                type="button" 
                className="btn btn-editar ml-2"
                data-toggle="modal"
                data-target="#modalCadastrarControleEmissaoBpeUsuario"
                onClick={() => editar(controle)}
                title="Editar">
                <i className="material-icons nav-icon">&#xe150;</i>
              </button>
              <button 
                type="button" 
                className="btn btn-excluir"
                data-toggle="modal"
                data-target="#modalConfirmacaoExclusaoControleUsuario"
                title="Excluir"
                onClick={() => excluir(controle.id)}>
                <i className="material-icons nav-icon">&#xe872;</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ModalConfirmacaoExclusaoControleUsuario = ({ excluir, controleId }) => (
  <div className="modal fade" id="modalConfirmacaoExclusaoControleUsuario" tabIndex="-1" role="dialog"
       aria-labelledby="modalConfirmacao" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body texto-centralizado">
          <p>Deseja excluir a configuração selecionada?</p>
        </div>
        <div className="modal-footer">
          <button 
            id='cancelar' 
            type="button" 
            className="btn btn-outline-secondary"
            data-dismiss="modal">
            Cancelar
          </button>
          <button 
            type="button" 
            className="btn btn-laranja float-left" 
            data-dismiss="modal"
            onClick={() => excluir(controleId)}>
            Excluir
          </button>
        </div>
      </div>
    </div>
  </div>
);

export class ListagemControleEmissaoBpeUsuario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      controleSelecionado: null
    };
    this.excluir = this.excluir.bind(this);
    this.selecionarControle = this.selecionarControle.bind(this);
  }

  selecionarControle(controleId) {
    this.setState({ controleSelecionado: controleId });
  }

  excluir(controleId) {
    this.props.excluirControleEmissaoBpeUsuario(controleId).then(() => {
      showSuccessMsg('Configuração excluída com sucesso');
      this.props.listarControles();
      this.setState({ controleSelecionado: null });
    });
  }

  editar(controle) {
    $('#modalCadastrarControleEmissaoBpeUsuario').modal('show');
    this.props.abrirModalEdicao(controle);
  }

  getLabelTipoPagamento(codigo) {
    const tipo = formasPagamentoControleEmissaoBpe.find(it => it.value === codigo);
    return tipo ? tipo.label : codigo;
  }

  render() {
    return (
      <div className="mt-4">
        <div className="row mb-3 align-items-center">
          <div className="col-md-8 col-lg-8">
            <div className="titulo-principal-componente">
              <h5 className="mb-0">Configurações por Usuário</h5>
            </div>
          </div>
          <div className="col-md-4 col-lg-4 text-right">
            <button 
              data-toggle="modal"
              data-target="#modalCadastrarControleEmissaoBpeUsuario"
              className="btn btn-laranja"
              onClick={() => {
                if (this.props.fecharModalEdicao) {
                  this.props.fecharModalEdicao();
                }
              }}>
              Nova Configuração
            </button>
          </div>
        </div>
        
        {!this.props.controles || this.props.controles.length === 0 ? (
          <div className="alert alert-info mt-3" role="alert">
            <i className="material-icons" style={{ verticalAlign: 'middle', marginRight: '8px' }}>&#xe88a;</i>
            Nenhuma configuração cadastrada. Clique em &quot;Nova Configuração&quot; para adicionar.
          </div>
        ) : (
          <>
            <CabecalhoTabelaControleUsuario />
            <div className="lista-tabela-dados">
              {this.props.controles.map((controle) => (
                <ControleUsuarioItem
                  key={controle.id}
                  controle={controle}
                  editar={this.editar.bind(this)}
                  excluir={this.selecionarControle}
                  getLabelTipoPagamento={this.getLabelTipoPagamento.bind(this)}
                />
              ))}
            </div>
          </>
        )}
        
        <ModalConfirmacaoExclusaoControleUsuario
          excluir={this.excluir}
          controleId={this.state.controleSelecionado}
        />
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    excluirControleEmissaoBpeUsuario
  }, dispatch)
);

export default connect(null, mapDispatchToProps)(ListagemControleEmissaoBpeUsuario);
